import { COMP_AGE, COMP_LIST, EVENT_STUDENT, EXP_LIST, ONGOING_EVENT_FILTER, PAST_EVENT_FILTER, PENDING_SUBMISSION_KIDS, QUIZ_LIST, RESET_FILTERS, SUBMISSION_LIST } from "../actions/types";
import { ACTIVITY_LIST, CATEGORY_LIST, EVENT_DETAILS, EVENT_PROPS, EXP_AGE, ONGOING_EVENTS, PAST_EVENTS, QUIZ_AGE } from "../actions/types";

const initialState = {
   ongoingEventFilter: {
      classes: [],
      programs: [],
      schools: [],
      sections: []
   },
   pastEventFilter: {
      classes: [],
      programs: [],
      schools: [],
      sections: []
   },
   ongoingEvents: {},
   pastEvents: {},
   eventDetails: {},
   eventProps: {},
   categoryList: [],
   activityList: [],
   compAge: "5",
   expAge: "5",
   quizAge: "6",
   compList: [],
   expList: [],
   quizList: [],
   pendingSubmissionKids: {},
   eventStudentList: {},
   submissionList: []
}

export default function (state = initialState, action) {

   const { type, payload } = action;
   switch (type) {
      case ONGOING_EVENTS:
         return { ...state, ongoingEvents: payload }
      case PAST_EVENTS:
         return { ...state, pastEvents: payload }
      case EVENT_DETAILS:
         return { ...state, eventDetails: payload }
      case EVENT_PROPS:
         return { ...state, eventProps: payload }
      case CATEGORY_LIST:
         return { ...state, categoryList: payload }
      case ACTIVITY_LIST:
         return { ...state, activityList: payload }
      case COMP_AGE:
         return { ...state, compAge: payload }
      case EXP_AGE:
         return { ...state, expAge: payload }
      case QUIZ_AGE:
         return { ...state, quizAge: payload }
      case COMP_LIST:
         return { ...state, compList: payload }
      case EXP_LIST:
         return { ...state, expList: payload }
      case QUIZ_LIST:
         return { ...state, quizList: payload }
      case PENDING_SUBMISSION_KIDS:
         return { ...state, pendingSubmissionKids: payload }
      case SUBMISSION_LIST:
         return { ...state, submissionList: payload }
      case EVENT_STUDENT:
         return { ...state, eventStudentList: payload }
      case ONGOING_EVENT_FILTER:
         return { ...state, ongoingEventFilter: payload }
      case PAST_EVENT_FILTER:
         return { ...state, pastEventFilter: payload }
      case RESET_FILTERS:
         return {
            ...state, ongoingEventFilter: {
               classes: [],
               programs: [],
               schools: [],
               sections: []
            },
            pastEventFilter: {
               classes: [],
               programs: [],
               schools: [],
               sections: []
            },
         }
      default:
         return state;
   }
}